let card = {
    "numbers": ["1", "2", "3"],
    "colors": ["Red", "Purple", "Green"],
    "shapes": ["Squiggle", "Diamond", "Oval"],
    "shades": ["Filled", "Shaded", "Empty"]
}


export const getDeck = () => {
    let d = [];
    for (let i = 0; i < 81; i ++) {
        d.push(i)
    }
    return d;
}


export const getText = (num) => {
    let number = num % 3
    num -= number;
    num /= 3;

    let color = num % 3
    num -= color;
    num /= 3;

    let shape = num % 3
    num -= shape;
    num /= 3;

    let shade = num

    return (card['numbers'][number] + " " + card['shades'][shade] + " " + card['colors'][color] + " " + card['shapes'][shape] + (number ? "s" : ""));
}


export const getMatch = (a, b) => {
    let anumber = a % 3
    a -= anumber;
    a /= 3;

    let acolor = a % 3
    a -= acolor;
    a /= 3;

    let ashape = a % 3
    a -= ashape;
    a /= 3;

    let ashade = a

    let bnumber = b % 3
    b -= bnumber;
    b /= 3;

    let bcolor = b % 3
    b -= bcolor;
    b /= 3;

    let bshape = b % 3
    b -= bshape;
    b /= 3;

    let bshade = b

    let cnumber = (bnumber * 2 - anumber + 3) % 3;
    let ccolor = (bcolor * 2 - acolor + 3) % 3;
    let cshape = (bshape * 2 - ashape + 3) % 3;
    let cshade = (bshade * 2 - ashade + 3) % 3;
    
    return cnumber + ccolor * 3 + cshape * 3**2 + cshade * 3**3;
}
